import { defineComponent as _defineComponent } from 'vue'
import { AbSlider, AbSliderItem } from '../../../ui';
import BlogSectionSimpleItem from './BlogSectionSimpleItem.vue';
import { type TextAlign } from '../../../../types';

interface Props {
  items: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
  }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionSimpleSlider',
  props: {
    items: null
  },
  emits: ["item-click", "active-index-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'item-click', index: number): void;
  (e: 'active-index-change', index: number): void;
}), expose: any, slots: any, attrs: any }) {




const onItemClick = (index: number) => emit('item-click', index);
const onRealIndexChange = (index: number) => emit('active-index-change', index);

return { __sfc: true,emit, onItemClick, onRealIndexChange, AbSlider, AbSliderItem, BlogSectionSimpleItem }
}

})